// @ts-expect-error -- inobounce ships no type declarations
export { default } from "inobounce";
